export default __webpack_public_path__ + "static/media/Equipe3.a3d28469.png";